/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem";
import search from "api/search/search.js";
import searchRestaurants from "api/search/search-by-name.js";
import SearchInput from "componentCustom/SearchInput.js";
import { NavLink } from "react-router-dom";
import config from "config/config.js";

import styles from "assets/jss/material-dashboard-pro-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const { updateCity } = props;
  const classes = useStyles();
  const { fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });
  const home = {position: "fixed",
  zIndex: 999,
  bottom: 0,
  left: 0,
  height: "315px",
  width: "100%"}
  const other = {
    height: "315px",
    width: "100%"}
    let history = useHistory();
    console.log(history)

  return (
    <footer style={other}>
      <div className="footer-container">
        <div className="footer-input-container">
          <div className="footer-input border-right">
            <SearchInput
              label={"Cerca: "}
              placeholder={"es.: Ristoranti..."}
              getElementSelected={elem => {
                updateCity(elem);
                if (elem.alias) {
                  // window.location.href = `${config.clientUrl}/restaurant?${elem.alias}`;
                  history.push(`/restaurant?${elem.alias}`)
                } else {
                  history.push(`/search?${
                    elem.latitude
                  }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`)
                  //
                  // window.location.href = `${config.clientUrl}/search?${
                  //   elem.latitude
                  // }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`;
                }
              }}
              search={(elem, timestamp) => {
                return searchRestaurants(elem, timestamp);
              }}
              labelColor={'#ffcb7f'}
            />
          </div>
          <div className="footer-input">
            <SearchInput
              label={"Dove: "}
              placeholder={"es.: La tua città"}
              getElementSelected={elem => {
                console.log("entro qui", elem);
                updateCity(elem);
                // if (elem.alias) {
                //   window.location.href = `${config.clientUrl}/restaurant?${elem.alias}`;
                // } else {
                //   window.location.href = `${config.clientUrl}/search?${
                //     elem.latitude
                //   }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`;
                // }
                if (elem.alias) {
                  // window.location.href = `${config.clientUrl}/restaurant?${elem.alias}`;
                  history.push(`/restaurant?${elem.alias}`)
                } else {
                  history.push(`/search?${
                    elem.latitude
                  }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`)
                  //
                  // window.location.href = `${config.clientUrl}/search?${
                  //   elem.latitude
                  // }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`;
                }
              }}
              search={(elem, timestamp) => {
                return search("13.9027424", "42.9118137", "it", elem, timestamp);
              }}
            />
          </div>
        </div>
      </div>
      {/* <div className="footer-buttons-container">
        <a>
          <button className="footer-buttons-link">
            <i className="fa fa-store-alt" />
            <div className="separator" />
            <span className="footer-button-label">Pescherie</span>
          </button>
        </a>
        <a>
          <button className="footer-buttons-link">
            <i className="fa fa-utensils" />
            <div className="separator" />
            <span className="footer-button-label">Ristoranti</span>
          </button>
        </a>
        <a>
          <button className="footer-buttons-link">
            <i className="fa fa-ship" />
            <div className="separator" />
            <span className="footer-button-label">Pescatori</span>
          </button>
        </a>
      </div>
      <div className="footer-eshop">
        <div>Visita il nostro negozio.</div>
        <a>e-shop</a>
      </div> */}
    </footer>
  );
}

Footer.propTypes = {
  updateCity: PropTypes.func.isRequired,
  city: PropTypes.object.isRequired
};
